module.exports = __webpack_public_path__ + "img/chakan.eddad066.png";